export const BONDS_ACTIONS = {
  GET_BONDS: 'GET_BONDS',
  GET_BONDS_REQUEST: 'GET_BONDS_REQUEST',
  GET_BONDS_ERROR: 'GET_BONDS_ERROR'
};
export const BONDS_NO_FILTER_ACTIONS = {
  GET_BONDS_NO_FILTER: 'GET_BONDS_NO_FILTER',
  GET_BONDS_NO_FILTER_REQUEST: 'GET_BONDS_NO_FILTER_REQUEST',
  GET_BONDS_NO_FILTER_ERROR: 'GET_BONDS_NO_FILTER_ERROR'
};
export const FULLTEXT_ACTIONS = {
  FULLTEXT_GET_RESPONSE: 'FULLTEXT_GET_RESPONSE',
  FULLTEXT_REQUEST: 'FULLTEXT_REQUEST',
  FULLTEXT_ERROR: 'FULLTEXT_ERROR'
};
export const FULLTEXT_ACTIONS_INBONDS = {
  FULLTEXT_ACTIONS_INBONDS_RESPONSE: 'FULLTEXT_ACTIONS_INBONDS_RESPONSE',
  FULLTEXT_ACTIONS_INBONDS_REQUEST: 'FULLTEXT_ACTIONS_INBONDS_REQUEST',
  FULLTEXT_ACTIONS_INBONDS_ERROR: 'FULLTEXT_ACTIONS_INBONDS_ERROR'
};
export const FOLLOW_BOND_ACTION = {
  FOLLOW_BOND: 'FOLLOW_BOND',
  FOLLOW_BOND__REQUEST: 'FOLLOW_BOND__REQUEST',
  FOLLOW_BOND__ERROR: 'FOLLOW_BOND__ERROR'
};


export const BONDS_SEARCH_CREATE_ACTIONS = {
  BONDS_SEARCH_CREATE_RESPONSE: 'BONDS_SEARCH_CREATE_RESPONSE',
  BONDS_SEARCH_CREATE_REQUEST: 'BONDS_SEARCH_CREATE_REQUEST',
  BONDS_SEARCH_CREATE_ERROR: 'BONDS_SEARCH_CREATE_ERROR',
};
export const SEARCHFILTER_RENAME_ACTIONS = {
  SEARCHFILTER_RENAME_RESPONSE: 'SEARCHFILTER_RENAME_RESPONSE',
  SEARCHFILTER_RENAME_REQUEST: 'SEARCHFILTER_RENAME_REQUEST',
  SEARCHFILTER_RENAME_ERROR: 'SEARCHFILTER_RENAME_ERROR',
};

export const BONDS_SEARCH_FILTER_DETAIL_ACTIONS = {
  BONDS_SEARCH_FILTER_DETAIL_RESPONSE: 'BONDS_SEARCH_FILTER_DETAIL_RESPONSE',
  BONDS_SEARCH_FILTER_DETAIL_REQUEST: 'BONDS_SEARCH_FILTER_DETAIL_REQUEST',
  BONDS_SEARCH_FILTER_DETAIL_ERROR: 'BONDS_SEARCH_FILTER_DETAIL_ERROR',
};

export const BONDS_SEARCH_FILTER_LIST_ACTIONS = {
  BONDS_SEARCH_FILTER_LIST_RESPONSE: 'BONDS_SEARCH_FILTER_LIST_RESPONSE',
  BONDS_SEARCH_FILTER_LIST_REQUEST: 'BONDS_SEARCH_FILTER_LIST_REQUEST',
  BONDS_SEARCH_FILTER_LIST_ERROR: 'BONDS_SEARCH_FILTER_LIST_ERROR',
};
export const BONDS_POSITION_DETAIL_ACTIONS = {
  BONDS_POSITION_DETAIL_RESPONSE: 'BONDS_POSITION_DETAIL_RESPONSE',
  BONDS_POSITION_DETAIL_REQUEST: 'BONDS_POSITION_DETAIL_REQUEST',
  BONDS_POSITION_DETAIL_ERROR: 'BONDS_POSITION_DETAIL_ERROR',
};
export const BONDS_POSITION_CREATE_ACTIONS = {
  BONDS_POSITION_CREATE_RESPONSE: 'BONDS_POSITION_CREATE_RESPONSE',
  BONDS_POSITION_CREATE_REQUEST: 'BONDS_POSITION_CREATE_REQUEST',
  BONDS_POSITION_CREATE_ERROR: 'BONDS_POSITION_CREATE_ERROR',
};
export const BONDS_POSITION_PORTFOLIO_DETAILS_ACTIONS = {
  BONDS_POSITION_PORTFOLIO_DETAILS_RESPONSE: 'BONDS_POSITION_PORTFOLIO_DETAIL_RESPONSE',
  BONDS_POSITION_PORTFOLIO_DETAILS_REQUEST: 'BONDS_POSITION_PORTFOLIO_DETAIL_REQUEST',
  BONDS_POSITION_PORTFOLIO_DETAILS_ERROR: 'BONDS_POSITION_PORTFOLIO_DETAIL_ERROR',
};
export const BONDS_POSITION_PRICEBYDATE_ACTIONS = {
  BONDS_POSITION_PRICEBYDATE_ACTIONS_RESPONSE: 'BONDS_POSITION_PRICEBYDATE_RESPONSE',
  BONDS_POSITION_PRICEBYDATE_ACTIONS_REQUEST: 'BONDS_POSITION_PRICEBYDATE_REQUEST',
  BONDS_POSITION_PRICEBYDATE_ACTIONS_ERROR: 'BONDS_POSITION_PRICEBYDATE_ERROR',
};
export const GET_ALLBONDS_ACTIONS = {
  GET_ALLBONDS_ACTIONS_RESPONSE: 'GET_ALLBONDS_ACTIONS_RESPONSE',
  GET_ALLBONDS_ACTIONS_REQUEST: 'GET_ALLBONDS_ACTIONS_REQUEST',
  GET_ALLBONDS_ACTIONS_ERROR: 'GET_ALLBONDS_ACTIONS_ERROR',
};
export const GET_CLIENT_IP = {
  GET_CLIENT_IP_RESPONSE: 'GET_CLIENT_IP_RESPONSE',
  GET_CLIENT_IP_REQUEST: 'GET_CLIENT_IP_REQUEST',
  GET_CLIENT_IP_ERROR: 'GET_CLIENT_IP_ERROR',
};
export const GET_ISSUER_LIST_BY_FIRST_LETTER = {
  GET_ISSUER_LIST_BY_FIRST_LETTER_RESPONSE: 'GET_ISSUER_LIST_BY_FIRST_LETTER_RESPONSE',
  GET_ISSUER_LIST_BY_FIRST_LETTER_REQUEST: 'GET_ISSUER_LIST_BY_FIRST_LETTER_REQUEST',
  GET_ISSUER_LIST_BY_FIRST_LETTER_ERROR: 'GET_ISSUER_LIST_BY_FIRST_LETTER_ERROR',
};
export const GET_ISSUER_FIRST_LETTER_LIST = {
  GET_ISSUER_FIRST_LETTER_LIST_RESPONSE: 'GET_ISSUER_FIRST_LETTER_LIST_RESPONSE',
  GET_ISSUER_FIRST_LETTER_LIST_REQUEST: 'GET_ISSUER_FIRST_LETTER_LIST_REQUEST',
  GET_ISSUER_FIRST_LETTER_LIST_ERROR: 'GET_ISSUER_LIST_BY_FIRST_LETTER_ERROR',
};
export const GET_ISSUER_LIST_BY_CHAR_ACTIONS = {
  GET_ISSUER_LIST_BY_CHAR_RESPONSE: 'GET_ISSUER_LIST_BY_CHAR_RESPONSE',
  GET_ISSUER_LIST_BY_CHAR_REQUEST: 'GET_ISSUER_LIST_BY_CHAR_REQUEST',
  GET_ISSUER_LIST_BY_CHAR_ERROR: 'GET_ISSUER_LIST_BY_LIST_BY_CHARR',
};
export const GET_ISSUER_HISTORY = {
  GET_ISSUER_HISTORY_RESPONSE: 'GET_ISSUER_HISTORY_RESPONSE',
  GET_ISSUER_HISTORY_REQUEST: 'GET_ISSUER_HISTORY_REQUEST',
  GET_ISSUER_HISTORY_ERROR: 'GET_ISSUER_HISTORY_ERROR',
};